import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import {MiniBriefAudience} from '../../campaignBrief/campaignBrief.types';
import {CampaignToolName} from '../copilotCampaigns.enums';

const inputSchema = z.object({
  audienceName: z.string().describe('The name of the audience to add.'),
});

function createAudienceTool() {
  async function execute({
    input: {audienceName},
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    const newAudience: MiniBriefAudience = {
      id: Math.floor(Math.random() * 1000) + 100,
      name: audienceName,
    };

    return toolResult(JSON.stringify(newAudience));
  }

  return tool({
    name: CampaignToolName.CreateAudience,
    displayName: 'Creating audience',
    description: 'Create an audience',
    execute,
    inputSchema,
  });
}

export default createAudienceTool;
